import React from 'react';
import { Container, Layer } from './style';

interface LoaderProps {
  className?: string;
}

const Loader = ({ className }: LoaderProps) => {
  return (
    <Layer className={className}>
      <Container className="lds-roller">
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
      </Container>
    </Layer>
  );
};

export default Loader;
